import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewChildren, QueryList, ElementRef, NgZone } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { AuthService } from 'src/app/services/auth/auth.service';
import { StaffLoginService } from 'src/app/services/staff-login/staff-login.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-verify-account',
  templateUrl: './verify-account.component.html',
  styleUrls: ['./verify-account.component.scss']
})
export class VerifyAccountComponent implements OnInit {
  @Input() login_response: any;
  @Input() from_page: any;
  @Output() userSitesTab: EventEmitter<any> = new EventEmitter<any>();
  @Output() loginDashboard: EventEmitter<any> = new EventEmitter<any>();
  @Output() selected_tab: EventEmitter<any> = new EventEmitter<any>();
  
  @ViewChildren('emailOtp') emailOtpElements: QueryList<ElementRef>;
  @ViewChildren('mobileOtp') mobileOtpElements: QueryList<ElementRef>;
  @ViewChild('emailVerifyBtn') emailVerifyBtn?: HTMLButtonElement;
  @ViewChild('mobileVerifyBtn') mobileVerifyBtn?: HTMLButtonElement;  

  verification_form: FormGroup;
  is_office_email_otp_timeout;
  is_mobile_otp_timeout;
  mobile_time_remaining;
  office_email_time_remaining;
  is_loading: boolean;
  is_mobile_verifying: boolean;
  is_email_verifying: boolean;
  is_verified: boolean;
  show_counter: boolean = false;
  account = {
    sms_verified: "0",
    email_verified: "0",
  }
  selectedIndex: any = 0;
  isDashbAccess: string = '';
  send_otp_response: any;
  counter: number = 2;
  
  // OTP input arrays
  emailOtpInputs: string[] = ['', '', '', '', '', ''];
  mobileOtpInputs: string[] = ['', '', '', '', '', ''];
  otpIndexes: number[] = [0, 1, 2, 3, 4, 5];
  trackByIndex(index: number) {
    return index;
  }

  private onDestroy = new Subject<void>();
  constructor(
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private router: Router,
    private ngZone: NgZone,
    private staffLoginService: StaffLoginService,
  ) {
    this.verification_form = formBuilder.group({
      mobile_number: [{ value: '', disabled: true }, Validators.required],
      office_email: [{ value: '', disabled: true }, Validators.required],
      mobile_no_otp: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(6)]],
      office_email_otp: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(6)]],
      country_code: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    this.is_verified = this.route.snapshot.queryParams?.is_verified == '1' ? true : false;
    this.verification_form.patchValue({
      mobile_number: this.login_response.data?.mobile,
      office_email: this.login_response.data?.office_email,
      country_code: this.login_response.data?.country_code
    })
    // if((this.login_response.data?.sms_verified != '1' && this.login_response.data?.mobile != '' && this.from_page != 'signup') && (this.login_response.data?.email_verified != '1' && this.login_response.data?.office_email != '')) {
    //   this.resendOTP('both');
    //   this.selectedIndex = 0;
    // } else if(this.login_response.data?.sms_verified != '1' && this.login_response.data?.mobile != '' && this.from_page != 'signup') {
    //   this.resendOTP('mobile');
    //   this.selectedIndex = 0;
    // } else {
    //   this.resendOTP('email');
    //   this.selectedIndex = 1;
    // }
    if (this.login_response.data?.email_verified != '1' && this.login_response.data?.office_email != '') {
      this.resendOTP('email');
      this.selectedIndex = 0;
    } else {
      this.resendOTP('mobile');
      this.selectedIndex = 1;
    };
    this.selected_tab.emit(this.selectedIndex);
  }

  showTimer() {
    const countdownInterval = setInterval(() => {
      this.counter--;
      if (this.counter <= 1) {
        clearInterval(countdownInterval);
        this.onNext();
      }
    }, 1000);
  }

  resendOTP(type) {
    this.verification_form.get('mobile_no_otp').setValue('');
    this.verification_form.get('office_email_otp').setValue('');
    
    // Clear segmented OTP inputs
    this.clearOtpInputs('email');
    this.clearOtpInputs('mobile');

    let credentials = {
      ...this.verification_form.getRawValue(),
      resend_otp: '0'
    };

    if (type == 'mobile' || type == 'both') {
      if (type != 'both') {
        credentials.resend_otp = '1';
      }
      this.mobile_time_remaining = 60;
      this.is_mobile_otp_timeout = true;
      let mobile_interval = setInterval(() => {
        this.mobile_time_remaining -= 1;
        if (!this.mobile_time_remaining) {
          clearInterval(mobile_interval);
          this.is_mobile_otp_timeout = false;
        }
      }, 1000);
    }
    if (type == 'email' || type == 'both') {
      if (type != 'both') {
        credentials.resend_otp = '2';
      }
      this.office_email_time_remaining = 60;
      this.is_office_email_otp_timeout = true;
      let email_interval = setInterval(() => {
        this.office_email_time_remaining -= 1;
        if (!this.office_email_time_remaining) {
          clearInterval(email_interval);
          this.is_office_email_otp_timeout = false;
        }
      }, 1000);
    }

    this.is_loading = true;
    if (this.from_page == 'signup') {
      this.authService.sendOTP(credentials).subscribe(
        (res: any) => {
          this.send_otp_response = res;
          this.is_loading = false;
          if (!(res.code == '1')) {
            this.snackBar.open(res.message);
          }
        },
        err => {
          this.is_loading = false;
          console.log(err);
        },
      );
    } else {
      credentials.username = type == 'email' ? this.verification_form.get('office_email').value : this.verification_form.get('mobile_number').value;
      this.authService.sendOtp(credentials).subscribe(
        (res: any) => {
          this.send_otp_response = res;
          this.is_loading = false;
          if (!(res.code == '1')) {
            this.snackBar.open(res.message);
          }
        },
        err => {
          this.is_loading = false;
          console.log(err);
        },
      );
    };
  }

  redirectToDashboard() {
    window.open(`${environment.base_url}/staff`, '_self');
  }

  showSkipBtn() {
    if ((this.login_response?.data?.skip_otp_verification == 'mobile' && this.selectedIndex == 1) || (this.login_response?.data?.skip_otp_verification == 'email' && this.selectedIndex == 0) || this.login_response?.data?.skip_otp_verification == 'both') {
      return true;
    };
    return false;
  }

  onNext() {
    // if (this.selectedIndex == 0) {
    //   if ((this.login_response.data?.email_verified != '1' && this.login_response.data?.office_email != '') && (this.login_response.data?.email_verified != '1' && this.login_response.data?.office_email != '')) {
    //     this.selectedIndex = 1;
    //   } else {
    //     if (this.from_page == 'signup') {
    //       this.loginDashboard.emit();
    //     } else if (this.login_response.data?.client_details?.length > 1) {
    //       this.userSitesTab.emit();
    //     } else {
    //       this.redirectToDashb();
    //     };
    //   };
    // } else
    if (this.from_page == 'signup') {
      this.loginDashboard.emit(this.from_page);
    } else if (this.login_response.data?.client_details?.length > 1) {
      this.userSitesTab.emit();
    } else {
      this.redirectToDashb();
    };
  }

  redirectToDashb() {
    const auth_modules = this.login_response.data?.authorised_modules ? this.login_response.data?.authorised_modules.replace(' ','').split(',') : [];

    if(this.login_response.data?.authorised_modules.match(this.login_response.data?.last_module)) {
      window.open(`${environment.base_url}/${this.login_response.data.last_module}`, '_self');
    } else {
      if (auth_modules?.length > 0) {
        window.open(`${environment.base_url}/${auth_modules[0]}`, '_self');
      } else {
        this.isDashbAccess = `Unauthorized Access.<br> Please contact Truein Support!`;
      };
    };
  }

  verifyAccount(type) {
    let credentials: any = {};

    if (this.from_page == 'signup') {
      credentials = {
        ...this.verification_form.getRawValue(),
        verify_otp: '0',
        region: this.login_response?.data?.client_region ? this.login_response?.data?.client_region : '',
        client_site_id: this.login_response?.data?.client_site_id ? this.login_response?.data?.client_site_id : ''
      };
      if (type != 'both') {
        if (type == 'mobile') {
          credentials.verify_otp = '1';
          this.is_mobile_verifying = true;
        } else {
          credentials.verify_otp = '2';
          this.is_email_verifying = true;
        }
      };

      this.authService.verifyClientOTP(credentials).pipe(takeUntil(this.onDestroy)).subscribe(
        (res: any) => {
          this.account = res.data;
          if (type == 'both') {
            if (this.account?.sms_verified != '1' && this.account?.email_verified != '1') {
              this.resendOTP('both');
            } else if (this.account?.sms_verified != '1') {
              this.resendOTP('mobile');
            } else if (this.account?.email_verified != '1') {
              this.resendOTP('email');
            }
          }
          if (this.account?.email_verified == '1') {
            if (this.account?.sms_verified != '1' && this.login_response.data?.mobile != '' && this.login_response.data?.country_code == '91' && this.selectedIndex == 0) {
              this.resendOTP('mobile');
              this.selectedIndex = 1 ;
            } else {
              this.loginDashboard.emit(this.from_page);
            };
          };

          this.is_loading = false;

          if (res.code != '1' && type != 'both') {
            this.snackBar.open(res.message)
          }
          this.is_mobile_verifying = false;
          this.is_email_verifying = false;
        },
        err => {
          this.is_loading = false;
          console.log(err);
        }
      )
    } else {
      credentials.uid = this.send_otp_response?.data?.uid;
      credentials.token = this.send_otp_response?.data?.token;
      credentials.otp = String(type == 'office_email' ? this.verification_form.get('office_email_otp').value : this.verification_form.get('mobile_no_otp').value);

      this.staffLoginService.verifyOtp(credentials).pipe(takeUntil(this.onDestroy)).subscribe(
        (res: any) => {
          this.account = res.data;

          if (res.code == '1') {
            if (this.login_response.data?.email_verified == '1' && this.login_response.data?.office_email != '') {
              this.account.email_verified = '1';
            };

            if (this.login_response.data?.sms_verified != '1' && this.login_response.data?.mobile != '' && this.selectedIndex == 0) {
              this.resendOTP('mobile');
              this.selectedIndex = 1 ;
            } else if (this.login_response?.data != null && this.login_response?.data?.existing_user == '1') {
              this.loginDashboard.emit(this.from_page);
            } else {
              // Store the data in the service before navigation
              this.authService.setLoginResponseData({...this.login_response, ...this.account});
              setTimeout(() => {
                this.router.navigate(['/reset-password']);
              });
            };

            if (res.code != '1' && type != 'both') {
              this.snackBar.open(res.message)
            };

          } else {
            this.snackBar.open(res.message)
          };

          this.is_mobile_verifying = false;
          this.is_email_verifying = false;
          this.is_loading = false;
        },
        err => {
          this.is_loading = false;
          console.log(err);
        },
      );
    };
  }

  getUserSitesTab() {
    this.userSitesTab.emit();
  }

  validateOTP(e): boolean {
    const charCode = e.which ? e.which : e.keyCode;
    if ((charCode < 48 || charCode > 57) || e.target?.value?.length > 5) {
      return false
    }
    return true
  }

  onTabChanged(event) {
    this.selected_tab.emit(event.index);
  }

  // OTP Input Handlers
  onOtpInput(event: any, index: number, type: 'email' | 'mobile') {
    const input = event.target as HTMLInputElement;
    let value = input.value;

    // Remove any non-numeric characters
    value = value.replace(/\D/g, '');

    // Take only the last character if multiple
    if (value.length > 1) {
      value = value.charAt(value.length - 1);
    }

    // Update the array
    if (type === 'email') {
      this.emailOtpInputs[index] = value;
    } else {
      this.mobileOtpInputs[index] = value;
    }

    // Force DOM to match our state (prevents "ghost" digits)
    input.value = value;

    // Update form control
    this.updateOtpFormControl(type);
  }

  onOtpKeyDown(event: KeyboardEvent, index: number, type: 'email' | 'mobile') {
    const input = event.target as HTMLInputElement;

    // Allow tab navigation
    if (event.key === 'Tab') return;

    const arr = type === 'email' ? this.emailOtpInputs : this.mobileOtpInputs;

    // Digit entry: handle here + prevent default so the keystroke doesn't "leak" into the next input
    if (/^\d$/.test(event.key)) {
      event.preventDefault();
      const digit = event.key;

      if (type === 'email') {
        this.emailOtpInputs[index] = digit;
      } else {
        this.mobileOtpInputs[index] = digit;
      }

      // Immediate UI update
      input.value = digit;
      this.updateOtpFormControl(type);

      if (index < 5) {
        this.focusOtpInput(index + 1, type);
      } else {
        this.focusVerifyButton(type);
      }
      return;
    }

    // Backspace: clear current; if current already empty then move to previous and clear it
    if (event.key === 'Backspace') {
      event.preventDefault();
      if (arr[index]) {
        arr[index] = '';
        input.value = '';
        this.updateOtpFormControl(type);
        return;
      }
      if (index > 0) {
        arr[index - 1] = '';
        this.updateOtpFormControl(type);
        this.focusOtpInput(index - 1, type);
      }
      return;
    }

    // Delete: clear current, stay on the same input
    if (event.key === 'Delete') {
      event.preventDefault();
      arr[index] = '';
      input.value = '';
      this.updateOtpFormControl(type);
      return;
    }

    // Handle arrow keys
    if (event.key === 'ArrowLeft' && index > 0) {
      event.preventDefault();
      this.focusOtpInput(index - 1, type);
    } else if (event.key === 'ArrowRight' && index < 5) {
      event.preventDefault();
      this.focusOtpInput(index + 1, type);
    }

    // Prevent arrow up/down
    if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
      event.preventDefault();
    }
  }

  onOtpPaste(event: ClipboardEvent, startIndex: number, type: 'email' | 'mobile') {
    event.preventDefault();
    const pastedData = event.clipboardData?.getData('text') || '';
    
    // Extract only digits from pasted data
    const digits = pastedData.replace(/\D/g, '').slice(0, 6);

    if (digits.length > 0) {
      // Distribute digits across inputs from the box user pasted into
      for (let i = 0; i < 6; i++) {
        const targetIndex = startIndex + i;
        if (targetIndex > 5) break;
        if (type === 'email') {
          this.emailOtpInputs[targetIndex] = digits[i] || '';
        } else {
          this.mobileOtpInputs[targetIndex] = digits[i] || '';
        }
      }
      
      // Update form control
      this.updateOtpFormControl(type);

      // Focus on the next empty input or the last one
      const nextIndex = Math.min(startIndex + digits.length, 5);
      if (startIndex + digits.length >= 6) {
        this.focusVerifyButton(type);
      } else {
        this.focusOtpInput(nextIndex, type);
      }
    }
  }

  private focusVerifyButton(type: 'email' | 'mobile') {
    const btn =
      type === 'email' ? this.emailVerifyBtn : this.mobileVerifyBtn;
  
    this.ngZone.onStable.pipe(take(1)).subscribe(() => {
      if (btn && !btn.disabled) {
        btn.focus();
      }
    });
  }
  
  
  focusOtpInput(index: number, type: 'email' | 'mobile') {
    setTimeout(() => {
      const elements = type === 'email' ? this.emailOtpElements : this.mobileOtpElements;
      if (elements && elements.toArray()[index]) {
        const el = elements.toArray()[index].nativeElement as HTMLInputElement;
        el.focus();
      }
    }, 0);
  }

  updateOtpFormControl(type: 'email' | 'mobile') {
    const otpValue = type === 'email' 
      ? this.emailOtpInputs.join('') 
      : this.mobileOtpInputs.join('');
    
    const controlName = type === 'email' ? 'office_email_otp' : 'mobile_no_otp';
    this.verification_form.get(controlName)?.setValue(otpValue);
    
    // Mark as touched if user has started entering
    if (otpValue.length > 0) {
      this.verification_form.get(controlName)?.markAsTouched();
    }
  }

  clearOtpInputs(type: 'email' | 'mobile') {
    if (type === 'email') {
      this.emailOtpInputs = ['', '', '', '', '', ''];
      this.verification_form.get('office_email_otp')?.markAsUntouched();
    } else {
      this.mobileOtpInputs = ['', '', '', '', '', ''];
      this.verification_form.get('mobile_no_otp')?.markAsUntouched();
    }
  }

  ngOnDestroy() {
    this.onDestroy.next();
    this.onDestroy.complete();
  }

}
